import { configureStore } from '@reduxjs/toolkit';
import billsReducer from './slices/billsSlice';
import membersReducer from './slices/membersSlice';
import chatReducer from './slices/chatSlice';
import appReducer from './slices/appSlice';

export const store = configureStore({
  reducer: {
    app: appReducer,
    bills: billsReducer,
    members: membersReducer,
    chat: chatReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
